import React from 'react';
import {connect} from 'react-redux';
import BlockConstructor from './BlockConstructor';
import {NotificationProvider} from '../../UI/Notifications';

const BlockConstructorWrapper = ({event}) => {
    return (
        <NotificationProvider>
            <BlockConstructor event={event} />
        </NotificationProvider>
    )
};

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	};
};

export default connect(mapStateToProps)(BlockConstructorWrapper);
